<template>
  <div v-show="showBackTop" class="back-top" @click="goBackTop">
    <div class="icon" />
    <div>回到顶部</div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from '#imports'

const showBackTop = ref(false)

function scrollFn() {
  showBackTop.value = window.scrollY > 600
}

function goBackTop() {
  window.scrollTo({ behavior: 'smooth', top: 0 })
}

onMounted(() => {
  scrollFn()
  window.addEventListener('scroll', scrollFn)
})

onUnmounted(() => {
  window.removeEventListener('scroll', scrollFn)
})
</script>

<style scoped lang="scss">
.back-top {
  position: fixed;
  right: 60px;
  bottom: 60px;
  width: 60px;
  height: 60px;
  border-radius: 31px;
  background: #e1e2ff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.14);
  color: #2c2d64;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  text-align: center;
  padding-top: 8px;
  z-index: 1;
  cursor: pointer;
  transition: all 0.3s;

  .icon {
    width: 24px;
    height: 24px;
    background-image: url('/images/top.svg');
    margin: 0 auto;
    transition: all 0.3s;
  }

  &:hover {
    background: #ffffff;
  }
}

@media screen and (orientation: portrait) {
  .back-top {
    display: none;
  }
}
</style>
